const endpoints = {
	getUserFromCompany: '/companies/users/getUserFromCompany',
	searchUsersFromCompany: '/companies/searchUsersFromCompany',
	createUserForCompany: '/companies/users/createUserForCompany',
	updateUserForCompany: '/companies/users/updateUserForCompany',
	removeUserFromCompany: '/companies/users/removeUserFromCompany',
	activateUserFromCompany: '/companies/users/activateUserFromCompany',
	updateUserCompanyPermissions: '/companies/users/updateUserCompanyPermissions',
	updateUserCompanyStatus: '/companies/users/updateUserCompanyStatus',
	getUserCompanyStatus: '/companies/users/getUserCompanyStatus',
	createConcept: '/concepts/createConcept',
	updateConcept: '/concepts/updateConcept',
	deleteConcept: '/concepts/deleteConcept',
	getConcepts: '/concepts/getConcepts',
	create: '/companies/create',
	update: '/companies/update',
	delete: '/companies/delete',
	restoreCompany: '/companies/restore',
	getAdminCompanies: 'companies/users/getAdminCompanies',
	createRole: '/roles/createRole',
	updateRole: '/roles/updateRole',
	updateRolesOrders: '/roles/updateRolesOrders',
	deleteRole: '/roles/deleteRole',
	getRoles: '/roles/getRoles',
	getProjectTypes: '/companies/getProjectTypes',
	createProjectType: '/companies/createProjectType',
	updateProjectType: '/companies/updateProjectType',
	updateProjectTypeOrders: '/companies/updateProjectTypeOrders',
	deleteProjectType: '/companies/deleteProjectType',
	createSpecialty: '/specialties/createSpecialty',
	updateSpecialty: '/specialties/updateSpecialty',
	deleteSpecialty: '/specialties/deleteSpecialty',
	getSpecialties: '/specialties/getSpecialties',
	updateCompanyConfig: '/companies/updateCompanyConfig',
	getCompanyConfig: '/companies/getCompanyConfig',
	updateOrCreateBankAccount: '/companies/updateOrCreateBankAccount',

	//Company Stages
	getAllCompanyStages: '/projects/planning/getAllCompanyStages',
	createCompanyStage: '/projects/planning/createCompanyStage',
	updateCompanyStage: '/projects/planning/updateCompanyStage',
	updateCompanyStageOrder: '/projects/planning/updateCompanyStageOrder',
	deleteCompanyStage: '/projects/planning/deleteCompanyStage',

	//Project Types
	createCompanyProjectTypeCategory: '/companies/project_types/createCompanyProjectTypeCategory',
	updateCompanyProjectTypeCategory: '/companies/project_types/updateCompanyProjectTypeCategory',
	deleteCompanyProjectTypeCategory: '/companies/project_types/deleteCompanyProjectTypeCategory',

	//Project Destinies
	createOrUpdateCompanyProjectDestiny: '/companies/destinies/createOrUpdateCompanyProjectDestiny',
	updateCompanyProjectDestinyOrders: '/companies/destinies/updateCompanyProjectDestinyOrders',
	getCompanyProjectDestinies: '/companies/destinies/getCompanyProjectDestinies',
	deleteCompanyProjectDestiny: '/companies/destinies/deleteCompanyProjectDestiny',

	//Unarchive
	createOrUpdateCompanyUnarchiveValue: '/companies/unarchive/createOrUpdateCompanyUnarchiveValue',
	getCompanyUnarchiveValues: '/companies/unarchive/getCompanyUnarchiveValues',
	deleteCompanyUnarchiveValue: '/companies/unarchive/deleteCompanyUnarchiveValue',

	//Templates
	getCompanyDocumentTemplates: '/companies/document_templates/getTemplates',
	getCompanyDocumentTemplate: '/companies/document_templates/getTemplate',
	createCompanyDocumentTemplate: '/companies/document_templates/createTemplate',
	updateCompanyDocumentTemplate: '/companies/document_templates/updateTemplate',
	deleteCompanyDocumentTemplate: '/companies/document_templates/deleteTemplate',

}
export {endpoints}